import { LOCAL_STORAGE_KEYS } from './local-storage.constant';
import LSM from './tool-local-storage';

// 只用于同步函数
export function autoSet(paramName: LOCAL_STORAGE_KEYS) {
    return function (targetPropertype: any, propName: string, descriptor: PropertyDescriptor) {
        const ori = descriptor.value
        descriptor.value = function (...args: any[]) {
            ori.call(this, ...args);
            LSM.set({
                path: paramName,
                value: args[0]
            })
        }
    }
}


// 异步函数